import { useState } from "react";
import "./mobile.scss";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { Company, Platform, Services, community, api } from "./data";
import { Link } from "react-router-dom";

function MobileFooter() {
  return (
    <div className="mobile-footer">
      <Expand title="Company" list={Company} />
      <Expand title="Platform" list={Platform} />
      <Expand title="Services" list={Services} />
      <Expand title="Community" list={community} />
      <Expand title="API" list={api} />
    </div>
  );
}
export default MobileFooter;

export function Expand(props) {
  function showLinks() {
    setExpand(!expand);
  }
  const [expand, setExpand] = useState(false);
  return (
    <div className="expand-footer-link">
      <div className="borderpart">
        <p onClick={showLinks}>
          {props.title}{" "}
          {expand === false ? <IoIosArrowDown /> : <IoIosArrowUp />}{" "}
        </p>
        {expand === true && (
          <div className={`footer-mobile`}>
            <ul>
              {props.list.map((item) => {
                return (
                  <Link to={item.to}>
                    <li>{item.link}</li>
                  </Link>
                );
              })}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}
